const AdminSectionCard = ({ title, subtitle, actions, className = '', bodyClassName = '', children }) => {
  const classes = ['admin-section-card', 'admin-surface-card', className].filter(Boolean).join(' ');
  const bodyClasses = ['admin-section-card-body', bodyClassName].filter(Boolean).join(' ');

  return (
    <section className={classes}>
      {(title || subtitle || actions) ? (
        <div className="admin-section-card-header">
          <div className="admin-section-card-heading">
            {title ? <h2 className="admin-section-card-title">{title}</h2> : null}
            {subtitle ? <p className="admin-section-card-subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="admin-section-card-actions">{actions}</div> : null}
        </div>
      ) : null}
      <div className={bodyClasses}>{children}</div>
    </section>
  );
};

export default AdminSectionCard;
